// The PostHog loader snippet, and the one project it reports to.
//
// This used to be an inline <script> in public/index.html, which ran on every
// build — develop included — so every environment recorded session replays into
// the production project. It lives here so the decision to run it can be made by
// the same resolver as every other environment-keyed decision (`portalEnv.js`)
// rather than by a second copy of "is this production" written into markup.
//
// Do not call this directly: `initPostHog()` in `posthog.js` is the gate. The
// project key is a publishable ingestion token, not a secret.

export const SNIPPET_KEY = "phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs"; // pragma: allowlist secret
export const SNIPPET_HOST = "https://us.i.posthog.com";
export const SNIPPET_OPTIONS = {
  api_host: SNIPPET_HOST,
  person_profiles: "identified_only",
  session_recording: {
    recordCrossOriginIframes: true,
  },
};

/**
 * Install the stock PostHog loader on `window.posthog`, then initialise it with
 * `SNIPPET_KEY` and `SNIPPET_OPTIONS`.
 *
 * The loader is PostHog's own snippet, kept as published; it queues calls on a
 * stub and injects the vendor's `array.js` from the assets host derived from
 * `api_host`.
 */
export function installPostHogSnippet() {
  /* eslint-disable */
    !(function (t, e) {
        var o, n, p, r;
        e.__SV ||
            ((window.posthog = e),
            (e._i = []),
            (e.init = function (i, s, a) {
                function g(t, e) {
                    var o = e.split(".");
                    2 == o.length && ((t = t[o[0]]), (e = o[1])),
                        (t[e] = function () {
                            t.push(
                                [e].concat(
                                    Array.prototype.slice.call(
                                        arguments,
                                        0,
                                    ),
                                ),
                            );
                        });
                }
                ((p = t.createElement("script")).type =
                    "text/javascript"),
                    (p.crossOrigin = "anonymous"),
                    (p.async = !0),
                    (p.src =
                        s.api_host.replace(
                            ".i.posthog.com",
                            "-assets.i.posthog.com",
                        ) + "/static/array.js"),
                    (r =
                        t.getElementsByTagName(
                            "script",
                        )[0]).parentNode.insertBefore(p, r);
                var u = e;
                for (
                    void 0 !== a ? (u = e[a] = []) : (a = "posthog"),
                        u.people = u.people || [],
                        u.toString = function (t) {
                            var e = "posthog";
                            return (
                                "posthog" !== a && (e += "." + a),
                                t || (e += " (stub)"),
                                e
                            );
                        },
                        u.people.toString = function () {
                            return u.toString(1) + ".people (stub)";
                        },
                        o =
                            "init me ws ys ps bs capture je Di ks register register_once register_for_session unregister unregister_for_session Ps getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey canRenderSurveyAsync identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty Es $s createPersonProfile Is opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing Ss debug xs getPageViewId captureTraceFeedback captureTraceMetric".split(
                                " ",
                            ),
                        n = 0;
                    n < o.length;
                    n++
                )
                    g(u, o[n]);
                e._i.push([i, s, a]);
            }),
            (e.__SV = 1));
    })(document, window.posthog || []);
  /* eslint-enable */
  window.posthog.init(SNIPPET_KEY, SNIPPET_OPTIONS);
}
